// Shared authored expression transforms, preserved for 2D and surface previews.
export const EMOTION_TRANSFORMS = {
    // x+ right, x- left, y+ down, y- up
    happy: {
        // Happy is the baseline - no transforms
        eyes: { shiftX: 0, shiftY: 0, scale: 1, rotation: 0 },
        mouth: { shiftX: 0, shiftY: 0, scale: 1, rotation: 0 },
    },
    sad: {
        eyes: { shiftX: 4, shiftY: 4, scale: 1, rotation: 180 },
        mouth: { shiftX: 0, shiftY: 2, scale: 1, rotation: 180 },
    },
    nervous: {
        eyes: { shiftX: 0, shiftY: 0, scale: 1.5, rotation: 0 },
        mouth: { shiftX: 0, shiftY: 0, scale: 0.67, rotation: -175 },
    },
    angry: {
        eyes: { shiftX: 4, shiftY: 0, scale: 0.67, rotation: 15 },
        mouth: { shiftX: 0, shiftY: 2, scale: 1.5, rotation: 180 },
    },
    surprised: {
        eyes: { shiftX: -4, shiftY: -4, scale: 1.5, rotation: -15 },
        mouth: { shiftX: 0, shiftY: 2, scale: 1.5, rotation: 0 },
    },
    dead: {
        eyes: { shiftX: 0, shiftY: 0, scale: 1, rotation: 0 },
        mouth: { shiftX: 0, shiftY: 2, scale: 1.5, rotation: 180 }, // Mouth uses angry version
    },
};
//# sourceMappingURL=expressionTransforms.js.map